import { Button } from "@mui/material"
import { useNavigate } from "react-router"

const BackButton = () => {
    const nav = useNavigate()
    const onClickBack = () => {
        nav('/')
    }
    return (
        <Button variant="contained" onClick={onClickBack}>
            Regresar
        </Button>
    )
}
export { BackButton }